export default "__VITE_ASSET__350c7061__"